import { animate, state, style, transition, trigger } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CaseDocumentModel } from 'src/app/models/case-document.model';
import { CaseModel } from 'src/app/models/case.model';
import { CaseService } from 'src/app/services/case.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UploadService } from 'src/app/services/upload.service';

@Component({
  selector: 'app-case-documents-list',
  templateUrl: './case-documents-list.component.html',
  styleUrls: ['./case-documents-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]

})
export class CaseDocumentsListComponent implements OnInit, OnDestroy {

  private componentDestroyed = new Subject();

  displayedColumns = ['Select', 'DocumentDate', 'UploadedBy', 'FileName', 'Size'];

  dataSource: MatTableDataSource<CaseDocumentModel> = new MatTableDataSource<CaseDocumentModel>();

  currentCase!: CaseModel;

  selection = new SelectionModel<CaseDocumentModel>(true, []);

  expandedRowIds!: string[];

  formatBytes = this.uploadService.formatBytes;

  constructor(
    private caseService: CaseService,
    private uploadService: UploadService,
    private spinnerService: SpinnerService) {

    this.caseService.currentCase
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (value: CaseModel | null) => {
          if (value !== null) {
            this.currentCase = value;
            this.expandedRowIds = this.currentCase.Events.map(e => e.Gid);

            let docs: CaseDocumentModel[] = this.currentCase.Events.flatMap(
              (e) => {
                let docs = e.Documents;
                if (docs.length > 0) {
                  docs[0].IsGroup = true;
                }
                return docs;
              });
            this.dataSource.data = docs;

          }
        }
      )
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }


  /* checkbox functions */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows(): void {
    this.isAllSelected() ? this.clearAllRows() : this.selectAllRows();
  }
  selectAllRows(): void {
    this.dataSource.data.forEach(row => {
      this.selection.select(row);
    });
  }
  clearAllRows(): void {
    this.selection.clear();
  }
  toggleRow(caseDocument: CaseDocumentModel) {
    this.selection.toggle(caseDocument);
  }

  documentGroupIsOpen(item: CaseDocumentModel): boolean {
    var open: boolean = this.expandedRowIds.findIndex(e => e === item.CaseEventId) > -1;
    return open;
  }

  toggleDocumentGroupOpenStatus(item: CaseDocumentModel): void {

    let rowIndex: number = this.expandedRowIds.findIndex(e => e === item.CaseEventId);
    if (rowIndex > -1) {
      this.expandedRowIds.splice(rowIndex, 1);
    }
    else {
      this.expandedRowIds.push(item.CaseEventId);
    }
  }

  isGroup(index: number, item: CaseDocumentModel): boolean {
    return item.IsGroup;
  }

  groupHasChildren(item: CaseDocumentModel): boolean {
    let elements = this.dataSource.data.filter(e => e.CaseEventId === item.CaseEventId);
    return elements.length > 1;
  }

  openDocument(document: CaseDocumentModel) {
    this.spinnerService.show("Henter dokumentet...")
    this.caseService.openDocument(document, this.currentCase.CaseUid);
  }

  downloadSelectedDocuments() {
    let documentIds: string[] = this.selection.selected.map(e => e.Id);
    this.caseService.downloadCaseFiles(documentIds, this.currentCase.CaseUid)
    this.clearAllRows();
  }
}
